class LocationsInventoryDrawer extends HTMLElement {
  constructor() {
    super();

    this.data = JSON.parse(this.querySelector('[data-data]').textContent);

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#LocationsInventoryDrawer-Overlay').addEventListener('click', this.close.bind(this));

    this.setupTriggerButton();
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.renderLocations();

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = document.getElementById('LocationsInventoryDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    document.querySelector('html').classList.add('overflow-hidden');
  }

  renderLocations() {
    const raw = window.sessionStorage.getItem('locationsWithStock');
    const locations = raw ? JSON.parse(raw) : [];

    const locationsContainer = document.getElementById('LocationsInventoryDrawer-Locations');
    locationsContainer.innerHTML = '';

    locations.forEach((location) => {
      const element = document.createElement('div');
      element.classList.add('location');

      location.items.forEach((item) => {
        const related = this.data.variants.find((variant) => variant.sku === item.sku);
        if (related) item.name = related.name;
      });

      location.items.sort((a, b) => this.#compareByVariantOrder(a.name, b.name));

      element.innerHTML = `
        <p class="location__name">${ location.name }</p>
        <p class="location__address">${ location.address.trim() }, ${ location.zip } ${ location.city }</p>
        <ul class="location__other-variants">
          ${ location.items.map((item) => `
            <li class="location__variant">
              <div class="location__variant__inner">
                ${ this.data.variants.find((variant) => variant.sku === item.sku).name }
              </div>
            </li>
          `).join('') }
        </ul>
      `;

      locationsContainer.appendChild(element);
    });
  }

  setupTriggerButton() {
    const triggerButton = document.querySelector('[data-locations-inventory-trigger]');
    triggerButton.setAttribute('role', 'button');
    triggerButton.setAttribute('aria-haspopup', 'dialog');

    triggerButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(triggerButton)
    });

    triggerButton.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(triggerButton);
      }
    });
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.querySelector("html").classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  #compareByVariantOrder(nameA, nameB) {
    const order = window.theme?.product?.variantSortingOrder || [];
    const indexA = order.indexOf(nameA);
    const indexB = order.indexOf(nameB);
    const inOrderA = indexA !== -1;
    const inOrderB = indexB !== -1;

    if (inOrderA && inOrderB) return indexA - indexB;
    if (inOrderA) return -1;
    if (inOrderB) return 1;

    const numA = this.#parseSize(nameA);
    const numB = this.#parseSize(nameB);

    if (!Number.isNaN(numA) && !Number.isNaN(numB) && numA !== numB) {
      return numA - numB;
    }

    return String(nameA ?? '').localeCompare(String(nameB ?? ''), undefined, { numeric: true });
  }

  #parseSize(name) {
    if (name == null || name === '') return NaN;

    const normalized = String(name).trim().replace(',', '.');

    if (!/^-?\d+(\.\d+)?$/.test(normalized)) return NaN;

    return Number(normalized);
  }

}

customElements.define('locations-inventory-drawer', LocationsInventoryDrawer);
